// extracted by mini-css-extract-plugin
module.exports = {"point":"PointLayout_point__5ytAc","sidebar":"PointLayout_sidebar__1m5JI","content":"PointLayout_content__1g9sg"};